import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import {ControlContainer, NgForm} from "@angular/forms";
import {MasterUseInstructionModel} from "web-shared";
import {MasterOperationModel} from "web-shared";
import {TaskSelectorModel} from "web-shared";
import {BaseComponent, ClassificatorValuesQuery, GLOBAL, Guid, LeModalService} from "common-shared";
import {IntegratedMasterService} from "../services/integrated-master.service";
import {PropertyService} from "web-shared";
import {filter, map, takeUntil} from "rxjs/operators";
import {TaskSelectorEditModalComponent} from "../task-selector-edit-modal/task-selector-edit-modal.component";
import {ResourceEditModalComponent} from "../../resources/resource-edit-modal/resource-edit-modal.component";
import {CopyPasteService} from "web-shared";
import {IImeFeatures} from "web-shared";
import {
  PropertyMappingEditorModalComponent
} from "../../../common/property-mapping/property-mapping-editor-modal/property-mapping-editor-modal.component";
import {ResourceService} from "../../resources/resource.service";
import {ResourceQuery} from "../../resources/models/resource.query";
import {MasterUseInstructionEditModalComponent} from "../master-use-instruction-edit-modal/master-use-instruction-edit-modal.component";
import {instanceToInstance} from "class-transformer";

@Component({
  selector: '[mes-master-use-instruction-edit]',
  templateUrl: './master-use-instruction-edit.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class MasterUseInstructionEditComponent extends BaseComponent implements OnInit {
  @Input() masterUseInstruction: MasterUseInstructionModel;
  @Input() masterOperation: MasterOperationModel;
  @Input() index: number;
  @Input() nrOfInstructionsInTaskSelector: number;
  @Input() taskSelector: TaskSelectorModel;
  @Input() settings: IImeFeatures;
  @Input() readonly: boolean = false;
  @Input() isAlternative: boolean = false;
  @Input() allowResourceTemplate: boolean = false;
  @Output() changed = new EventEmitter<MasterUseInstructionModel>();
  resourceTemplates$ = this.resourceService.getAll$.pipe(map(resources => resources.filter(resource => resource.KindClv == GLOBAL.Classificators.ResourceKind.Template)));

  constructor(public classificatorValuesQuery: ClassificatorValuesQuery, public resourceService: ResourceService, public integratedMasterService: IntegratedMasterService, public propertyService: PropertyService, private modalService: LeModalService, public copyPasteService: CopyPasteService) {
    super();
  }

  ngOnInit() {
  }

  setMainResource(mo, mui) {
    mui.IsMainResource = !mui.IsMainResource;
    this.changed.emit();
  }

  editOperationItemProperties(mo: MasterOperationModel, mui?: MasterUseInstructionModel, ensureWeightProperty = false, btn: HTMLElement = null) {
    const initialState = this.integratedMasterService.editOperationItemProperties({mo: mo, mui: mui, ensureWeightProperty: ensureWeightProperty});
    const modalRef = this.modalService.show(PropertyMappingEditorModalComponent, {initialState, class: 'modal-xl'});

    modalRef.onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      if (btn) {
        btn.focus();
      }
    });
  }

  edit() {
    this.modalService.show(MasterUseInstructionEditModalComponent, {initialState: {masterInstruction: this.masterUseInstruction, masterOperation: this.masterOperation, readonly: this.readonly}, class: 'modal-xl'})
      .onHide$.pipe(filter(value => value?.data !== null), takeUntil(this.componentDestroyed)).subscribe(() => {
      this.masterUseInstruction = instanceToInstance(this.masterUseInstruction);
      this.changed.emit();
    });
  }

  addNewTaskSelector() {
    this.modalService.show(TaskSelectorEditModalComponent, {initialState: {taskSelector: new TaskSelectorModel({Id: Guid.create()}), mode: "add"}, class: 'modal-xl'})
      .onHide$.pipe(filter(value => value?.data !== null), takeUntil(this.componentDestroyed)).subscribe(value => {
      this.masterOperation.TaskSelectors = this.masterOperation.TaskSelectors ? [...this.masterOperation.TaskSelectors, value.data] : [value.data];
      this.changeSelector(value.data);
      this.changed.emit();
      return value.data;
    });
  }

  changeSelector(ts: TaskSelectorModel) {
    this.masterUseInstruction.TaskSelectorId = this.masterUseInstruction.TaskSelectorId === ts.Id ? undefined : ts.Id;
    this.masterOperation.MasterUseInstructions = [...this.masterOperation.MasterUseInstructions];
    this.changed.emit();
  }

  paste(masterOperation: MasterOperationModel, fromClipboard: boolean = false) {
    this.copyPasteService.paste('MasterInstruction', masterOperation, null, this.taskSelector, fromClipboard).then(() => {
      this.changed.emit();
    });
  }

  openResourceEditModal(resourceId: string) {
    this.modalService.show(ResourceEditModalComponent, {initialState: {entityId: resourceId}, class: 'modal-xl'});
  }

  updateUserSpecifiedResources(resource: ResourceQuery) {
    this.integratedMasterService.updateUserSpecifiedResources(resource, this.masterUseInstruction);
    this.changed.emit();
  }
}
